/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ChainingComparison {
    OR = 'or',
    AND = 'and',
}
